import { ReactNode } from 'react';
import styled from 'styled-components';
import { shareImageFullWidth } from '../../../common/renderer/renderer-settings';
import { RenderOptions, RenderViewComponentParams, RenderViewComponentType } from '../../../common/renderer/types';
import { getScreenshotAreaStyle } from './utils/get-screenshot-area-style';
import { RenderViewImpactChart } from './components/render-view-impact-chart';
import { RenderViewContextProvider, useRenderViewContextBuilder } from './context';
import { useSetDefaultModelVersionAndRelease } from '../root/context/use-load-default-version-and-release';

export default function RenderApiProfile() {
  const context = useRenderViewContextBuilder();
  const { options } = context;
  const setDefaultRelease = useSetDefaultModelVersionAndRelease();
  const width = options.width || shareImageFullWidth;
  const components = context.componentParams.map(params => getComponent(params, width));

  const { version, release } = options;
  if (version && release) {
    setDefaultRelease(version, release);
    return (
      <RenderViewContextProvider value={context}>
        <ScreenshotArea options={{ ...options, width }}>{components}</ScreenshotArea>
      </RenderViewContextProvider>
    );
  } else {
    return <></>;
  }
}

type ScreenshotAreaProps = Partial<RenderOptions>;

const ScreenshotArea = styled.div<{ options: ScreenshotAreaProps }>`
  ${props => getScreenshotAreaStyle(props.options)}
`;

const getComponent = (params: RenderViewComponentParams, width: number): ReactNode => {
  const key = params.componentType;
  switch (params.componentType) {
    case RenderViewComponentType.IMPACT_CHART:
      return <RenderViewImpactChart {...{ width, params, key }} />;
    default:
      return <div>NOT IMPLEMENTED YET</div>;
  }
};
